import { s as server2server } from "../../../../../chunks/server2server.js";
const load = async (load2) => {
  const api = server2server(load2);
  api.requiresLogin();
  let associates = [];
  if (load2.locals.user?.associations) {
    for (let i = 0; i < load2.locals.user?.associations?.length; i++) {
      associates = [...associates, ...await api.get("/associates/customer/" + load2.locals.user?.associations[i]?.customer.uuid)];
    }
  }
  try {
    return {
      roles: await api.get("/auth/permission-roles"),
      associates,
      page_title: "Access"
    };
  } catch (e) {
    console.log("Error loading roles");
    api.reauthenticate();
  }
};
const actions = {
  create_role: async ({ request, locals, fetch, params, url, cookies }) => {
    const api = server2server({ cookies, url, locals });
    const formData = await request.formData();
    api.requiresLogin();
    const menuJson = formData.get("menuJson");
    try {
      return {
        roles: await api.post("/auth/permission-role", {
          name: formData.get("name"),
          menuJson: menuJson?.toString().split(",")
        })
      };
    } catch (e) {
      console.log("Error storing roles", e);
      api.reauthenticate();
    }
  }
};
export {
  actions,
  load
};
//# sourceMappingURL=_page.server.ts.js.map
